import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

/**
 * Firebase Configuration
 * Firebase Project: learnforfun-82a63
 * 
 * Configuration values are loaded from environment variables with fallback defaults.
 * Set these in your .env file:
 * - REACT_APP_FIREBASE_API_KEY
 * - REACT_APP_FIREBASE_AUTH_DOMAIN
 * - REACT_APP_FIREBASE_PROJECT_ID
 * - REACT_APP_FIREBASE_STORAGE_BUCKET
 * - REACT_APP_FIREBASE_MESSAGING_SENDER_ID
 * - REACT_APP_FIREBASE_APP_ID
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "your-api-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "learnforfun-82a63.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "learnforfun-82a63",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "learnforfun-82a63.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "your-messaging-sender-id",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Functions
export const functions = getFunctions(app);

/**
 * Configure Auth Persistence
 * 
 * Options:
 * - browserLocalPersistence (default): Persists across browser sessions (stays logged in after restart)
 * - browserSessionPersistence: Only persists for current browser session (clears when browser closes)
 * - inMemoryPersistence: No persistence (clears on page refresh)
 * 
 * Current: Using browserSessionPersistence - sessions only persist for current browser session
 * To change: Modify the setPersistence call below
 */
setPersistence(auth, browserSessionPersistence)
  .catch((error) => {
    console.error('Failed to set auth persistence:', error);
  });

export default app;

